import { render, staticRenderFns } from "./CompanyLink.vue?vue&type=template&id=1a8fa492&scoped=true&"
import script from "./CompanyLink.vue?vue&type=script&lang=js&"
export * from "./CompanyLink.vue?vue&type=script&lang=js&"
import style0 from "./CompanyLink.vue?vue&type=style&index=0&id=1a8fa492&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8fa492",
  null
  
)

export default component.exports